import { useEffect, useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalEditUser.css";
import { userService } from "../../services/user.service";
import { closeModal, showModal } from "../../utils/functions/modal";

const ModalEditUser = ({ setMessage, user, onSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    setUsername(user?.username || "");
    setPassword("");
  }, [user]);

  const handleSubmitUser = async (e) => {
    e.preventDefault();
    if (!user?.id) return;

    closeModal(".container-modal-edit-user");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Editando usuario...",
      status: 1000,
    });

    const payload = { id: user.id, username: username.trim() };
    if (password !== "") {
      payload.password = password;
    }

    const response = await userService.editUser(payload);

    setTimeout(() => {
      if (response.data.status === 200) {
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1000);
  };

  return (
    <div className="container-modal container-modal-edit-user">
      <div className="modal modal-edit-user">
        <div className="header-modal">
          <h3>Editar Usuario</h3>
          <button onClick={() => closeModal(".container-modal-edit-user")}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <form onSubmit={handleSubmitUser} className="body-modal">
          <div className="input">
            <label htmlFor="usernameEditUser">Usuario</label>
            <input
              type="text"
              id="usernameEditUser"
              name="usernameEditUser"
              required
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              placeholder="nombre@colibriapp.com"
            />
          </div>
          <div className="input">
            <label htmlFor="passwordEditUser">Nueva contraseña</label>
            <input
              type="password"
              id="passwordEditUser"
              name="passwordEditUser"
              minLength={8}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              placeholder="Dejar en blanco para no cambiarla"
            />
            <span className="hint">Mínimo 8 caracteres si la vas a cambiar</span>
          </div>

          <button className="btn-add-product">GUARDAR CAMBIOS</button>
        </form>
      </div>
    </div>
  );
};

export default ModalEditUser;
